let step = 80,
    scrolling = false;

function scrollContentV(direction) {
    var amount = (direction === "up" ? "-=1px" : "+=1px");
    $("#thumbs-container-v").animate({
        scrollTop: amount
    }, 1, function () {
        if (scrolling) {
            scrollContentV(direction);
        }
    });
}

function scrollContentH(direction) {
    var amount = (direction === "left" ? "-=1px" : "+=1px");
    $("#thumbs-container-h").animate({
        scrollLeft: amount
    }, 1, function () {
        if (scrolling) {
            scrollContentH(direction);
        }
    });
}

export function clickCarouselScroll() {
    $('#scroll-arrow-up').on('click', this, function (event) {
        event.preventDefault();
        $('#thumbs-container-v').animate({
            scrollTop: "-=" + step + "px"
        });
    }).mouseenter(function (event) {
        scrolling = true;
        scrollContentV("up");
    }).mouseleave(function (event) {
        scrolling = false;
    });

    $('#scroll-arrow-down').on('click', this, function (event) {
        event.preventDefault();
        $('#thumbs-container-v').animate({
            scrollTop: "+=" + step + "px"
        });
    }).mouseenter(function (event) {
        scrolling = true;
        scrollContentV("down");
    }).mouseleave(function (event) {
        scrolling = false;
    });

    $('#scroll-arrow-left').on('click', this, function (event) {
        event.preventDefault();
        $('#thumbs-container-h').animate({
            scrollLeft: "-=" + step + "px"
        });
    }).mouseenter(function (event) {
        scrolling = true;
        scrollContentH("left");
    }).mouseleave(function (event) {
        scrolling = false;
    });

    $('#scroll-arrow-right').on('click', this, function (event) {
        event.preventDefault();
        $('#thumbs-container-h').animate({
            scrollLeft: "+=" + step + "px"
        });
    }).mouseenter(function (event) {
        scrolling = true;
        scrollContentH("right");
    }).mouseleave(function (event) {
        scrolling = false;
    });
}